// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 445) return "static/chunks/1bfc9850-a38fb59cd89ffed4.js";
	if (chunkId === 151) return "static/chunks/151-b50b7e7c70805f50.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 142 ? "ed150ef9" : chunkId) + "." + {"142":"424f532c6cf8f9ca","572":"0f71ed28e042fac4"}[chunkId] + ".js";
};